import DS from 'ember-data';
import moment from 'moment';
import FloatingDate from 'floating-date/utils/floating-date';

// This transform provides methods to deserialize/serialize between an
// ISO 8601 date string and a FloatingDate object.
export default DS.Transform.extend({
  deserialize(serialized) {
    const [year, month, day] = (serialized || '').split('-').map((d) => {
      const parsed = parseInt(d);
      if (isNaN(parsed)) {
        return null;
      }

      return parsed;
    });

    return FloatingDate.create({
      year,
      month,
      day,
    });
  },

  serialize(deserialized) {
    if (deserialized === null) {
      return null;
    }

    const jsDate = deserialized.get('jsDate');
    if (jsDate === null) {
      return null;
    }

    return moment(jsDate).format('YYYY-MM-DD');
  },
});
